import { AxiosError } from 'axios';
import { User } from '@/models/User';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';

@Component<RequestStylistFilter>({})
export default class RequestStylistFilter extends Vue {
  @Prop()
  private value!: Item;

  private users: User[] = [];

  private search: string = '';

  private isSearching = false;

  private mounted(): void {
    this.fetchStylists(this.search);
  }

  private handleInput(item: Item): void {
    this.$emit('input', item);
  }

  private getFilters(search: string): UserListFilters {
    return {
      'role': 'stylist',
      ...search ? { search } : {},
      'is_active' : true,
    };
  }

  private async fetchStylists(search: string): Promise<void> {
    if (this.isSearching) {
      return;
    }
    this.isSearching = true;
    const users: User[] = await new User()
      .filter(this.getFilters(search))
      .sort('name')
      .limit(999)
      .all()
      .catch((error: AxiosError): User[] => {
        ErrorHandler.network(error);
        return [];
      });
    this.users = users;
    this.isSearching = false;
  }

  protected get items(): Item[] {
    const nonStylists: Item[] = [
      {
        value: 'not-assigned',
        text: 'Zonder styliste',
      }
    ];

    const stylists = this.users.map((user: User): Item => {
      return {
        value: user.id ? user.id : '',
        text: user.name ? user.name : '',
      };
    });

    return [...nonStylists, ...stylists];
  }

  @Watch('search')
  private searchChanged(search: string) {
    (this as any).$debounce('fetchStylists', search);
  }
}

type Item = {
  value: string;
  text: string;
};

type UserListFilters = {
  role?: string,
  search?: string,
  is_active?: boolean,
}
